import { CALL_HISTORY_METHOD } from 'react-router-redux';

export const languageMiddleware = store => next => action => {
    if (action.type !== CALL_HISTORY_METHOD) {
      return next(action);
    }

    const { payload: { args } } = action;
    let { i18nState: { lang } } = store.getState();

    if(args[0]){
      if( args[0].match(/^\/[a-z]{2}\//) )
        args[0] = args[0].substring(3);

      if( args[0].startsWith('/') )
        args[0] = '/' + lang + '/' + args[0].substring(1);
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/redux/middleware/languageMiddleware.js